// /* JWT */
// const CLAIM_ROLE =
//   "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
// const CLAIM_ADRESS =
//   "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";

// export {
//   /* CLAIMS */
//   CLAIM_ROLE,
//   CLAIM_ADRESS,
// };

import { IUserAuthenticate } from "../../auth/interface/IAuth";

/* JWT */
const CLAIM_ROLE =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
const CLAIM_ADRESS =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";
const CLAIM_PERSONA_ID = "Falcon";
const CLAIM_CUSTOMER_ID = "Mega";
const CLAIM_CUENTA = "Cuenta";
const CLAIM_CUENTA_ID = "Zero";
const CLAIM_USER_ID = "Bandicoot";
const CLAIM_CUSTOMER = "Customer";
const CLAIM_COD_CONT = "Dixit";
const CLAIM_TOKEN_SESION_C = "Poker";

/* Role */
const ROLE_ADMIN = "Admin";

const R_GESTION_DOC = "ssoma.GestionDocumentos";
const R_LECTURA_DOC = "ssoma.LecturaDocumentos";

/* Function */
const isRol = (access: IUserAuthenticate, rol: string) => {
  if (access.role) {
    if (access.role.find((x) => x == rol)) {
      return true;
    }
  }

  return false;
};

export {
  /* CLAIMS */
  CLAIM_ROLE,
  CLAIM_ADRESS,
  CLAIM_PERSONA_ID,
  CLAIM_CUSTOMER_ID,
  CLAIM_CUENTA,
  CLAIM_CUENTA_ID,
  CLAIM_USER_ID,
  CLAIM_CUSTOMER,
  CLAIM_COD_CONT,
  CLAIM_TOKEN_SESION_C,
  /* ROLE */
  ROLE_ADMIN,
  R_GESTION_DOC,
  R_LECTURA_DOC,

  /* Function */
  isRol,
};
